import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CookieChoice, readCookieChoice, saveCookieChoice } from './cookieConsent';
import './cookieConsent.scss';

const CookieConsentBanner = () => {
  const [choice, setChoice] = useState<CookieChoice | null>(readCookieChoice);

  const selectChoice = (nextChoice: CookieChoice) => {
    saveCookieChoice(nextChoice);
    setChoice(nextChoice);
  };

  if (choice) return null;

  return (
    <aside className="cookie-consent" aria-label="Cookie preferences" role="region">
      <div>
        <p className="cookie-consent__title">Your privacy choices</p>
        <p>
          Essential storage keeps your cart and checkout working. Optional analytics helps us improve the store.
          Read the <Link to="/cookies">Cookie Policy</Link>.
        </p>
      </div>
      <div className="cookie-consent__actions">
        <button type="button" className="cookie-consent__secondary" onClick={() => selectChoice('essential')}>
          Essential only
        </button>
        <button type="button" onClick={() => selectChoice('analytics')}>Accept analytics</button>
      </div>
    </aside>
  );
};

export default CookieConsentBanner;
